import React, { useEffect, useState } from "react";
import InputField from "../../../../components/InputField";
import TextArea from "../../../../components/TextArea";
import { getMailPatternForQR } from "../../../../helper/functions";

interface Props {
  setValue: (value: string) => void;
  prefilledValue?: {
    mailId: string;
    subject: string;
    message: string;
  };
  errors?: {
    mailIdError: string;
    subjectError: string;
    bodyError: string;
  };
}

const GenerateEmailQr: React.FC<Props> = ({
  setValue,
  prefilledValue,
  errors,
}) => {
  const [mailId, setMailId] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    if (prefilledValue) {
      setMailId(prefilledValue.mailId);
      setSubject(prefilledValue.subject);
      setBody(prefilledValue.message);
    }
  }, [prefilledValue]);

  return (
    <>
      <InputField
        name="email-id"
        value={mailId}
        onChange={(e) => {
          setMailId(e.target.value);
          setValue(getMailPatternForQR(e.target.value, subject, body));
        }}
        type="text"
        label="Mail ID"
        placeholder="Enter your email here..."
        error={errors?.mailIdError}
      />
      <InputField
        name="email-subject"
        value={subject}
        onChange={(e) => {
          setSubject(e.target.value);
          setValue(getMailPatternForQR(mailId, e.target.value, body));
        }}
        type="text"
        label="Subject"
        placeholder="Enter your subject here..."
        error={errors?.subjectError}
      />

      <TextArea
        name="email-body"
        value={body}
        onChange={(e) => {
          setBody(e.target.value);
          setValue(getMailPatternForQR(mailId, subject, e.target.value));
        }}
        label="Mail body"
        placeholder="Enter mail body here..."
        error={errors?.bodyError}
      />
    </>
  );
};

export default GenerateEmailQr;
